module.exports = __webpack_public_path__ + "img/23.138f44d4.png";